import React, { useContext } from "react";
import { LayoutContext } from "../../hooks/layout-context";
import { useTranslation } from "react-i18next";
import EmployeeForm from "../../components/forms/employee-form";

export default function EmployeeAdd() {
  const { t } = useTranslation();
  const { layout, setLayout } = useContext(LayoutContext);

  React.useEffect(() => {
    layout.sideMenu = "employee";
    layout.breadcrumbs = [
      { label: t("Pracownicy"), path: "/employee" },
      { path: null, label: t("Dodaj") },
    ];
    setLayout({ ...layout });
  }, []);

  return <EmployeeForm />;
}
